import React, { useEffect } from 'react';
import styled from 'styled-components';
import { COLORS, BackButton, Size, SystemIcons, ComponentL, ComponentXXS } from '@laerdal/life-react-components';
import { useTranslation } from 'react-i18next';
import { StepContainer } from './StepComponents';
import posthog from 'posthog-js';


const Container = styled.div`
    display: flex;
    padding: 32px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    align-self: stretch;

    border-radius: 8px;
    background: #FFF;

`;

const IconContainer = styled.div`
    display: flex;
    width: 64px;
    height: 64px;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border-radius: 64px;
    border: 2px solid ${COLORS.correct_500};
`;


interface StepResolvedProps {
  onPrevious?: () => void;
}

const StepResolved: React.FC<StepResolvedProps> = ({   onPrevious }) => {
  const { t } = useTranslation(['translation', 'qcprSupport']);

  useEffect(() => {
    // Track when user reaches the resolved state
    posthog.capture('SUPP-QcprSupport-TroubleshootingResolvedPageVisit', {
      page: 'StepResolved'
    });
  }, []);

  const handleBackClick = () => {
    posthog.capture('SUPP-QcprSupport-TroubleshootingResolvedBackClicked', {
      page: 'StepResolved'
    });
    onPrevious?.();
  };

  return (
    <StepContainer>
        <BackButton onClick={handleBackClick} size={Size.Small} >
            {t('Back', { ns: 'qcprSupport' })}
        </BackButton>
        
        <Container>
            <IconContainer>
                <SystemIcons.CheckMark size='32px' color={COLORS.correct_500} />
            </IconContainer>
            <ComponentL>
                {t("Glad it's working now!", { ns: 'qcprSupport' })}
            </ComponentL>
            <ComponentXXS>
                {t("You're all set", { ns: 'qcprSupport' })}
            </ComponentXXS>
        </Container>
    </StepContainer>
  );
};

export default StepResolved;
